import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

// Components
import { Box, useMediaQuery } from '@mui/material';
import Header from './components/Header';
import DetailsSection from './components/DetailsSection';
import TotalsSection from './components/TotalsSection';
import ConfirmSubscriptionCardNavigationButtons from './components/ConfirmSubscriptionCardNavigationButtons';

// Styles
import * as styles from './ConfirmSubscriptionCard.styles';

const ConfirmSubscriptionCard = props => {
  const {
    affiliateList,
    effectiveDate,
    endDate,
    onEnroll,
    onGoBack,
    planSelected,
    selectedAffiliate,
    setData,
  } = props;
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });

  return (
    <>
      <Box sx={styles.cardContainer}>
        <Header affiliateList={affiliateList} tierPlanName={planSelected?.tierPlanName} />
        <DetailsSection
          affiliateList={affiliateList}
          overageRate={planSelected?.overageRate}
          selectedAffiliate={selectedAffiliate}
          setData={setData}
          tierFixedFee={planSelected?.tierFixedFee}
          tierRate={planSelected?.tierRate}
          tierVolume={planSelected?.maxThreshold}
        />
        <TotalsSection
          effectiveDate={effectiveDate}
          endDate={endDate}
          tierRate={planSelected?.tierRate}
          tierVolume={planSelected?.maxThreshold}
        />
        {mdUp && (
          <ConfirmSubscriptionCardNavigationButtons
            disabled={!selectedAffiliate?.nameShort}
            onEnroll={onEnroll}
            onGoBack={onGoBack}
          />
        )}
      </Box>
    </>
  );
};

ConfirmSubscriptionCard.propTypes = {
  affiliateList: arrayOf(shape({})).isRequired,
  effectiveDate: string.isRequired,
  endDate: string.isRequired,
  onEnroll: func.isRequired,
  onGoBack: func.isRequired,
  planSelected: shape({}).isRequired,
  selectedAffiliate: shape({}).isRequired,
  setData: func.isRequired,
};

export default ConfirmSubscriptionCard;
